import { render, staticRenderFns } from "./SplitListDetail.vue?vue&type=template&id=72fa87a4&scoped=true"
import script from "./SplitListDetail.vue?vue&type=script&lang=js"
export * from "./SplitListDetail.vue?vue&type=script&lang=js"
import style0 from "./SplitListDetail.vue?vue&type=style&index=0&id=72fa87a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa87a4",
  null
  
)

export default component.exports